import {
  SET_USERS_LIST,
  SET_MESSAGES_LIST,
  ADD_MESSAGE,
  SET_CHAT_SETTINGS,
  SET_ERROR_MESSAGE,
  SET_USER_BLOCKED,
  SET_MESSAGE_DELETED,
  SET_IS_USER_CONNECTED,
  SET_IS_SOCKET_OPENED,
} from '../../util/actionTypes'

import {
  SocketAction,
  StateType,
  MessageType,
  DeletedMessageType,
} from './useSocket.types'

import { sortMessagesByDate } from '../../util/util'

const initialState = {
  usersList: [],
  messagesList: [],
  isNotificationsEnabled: false,
  error: '',
  isUserBlocked: false,
  isUserConnected: false,
  isSocketOpened: false,
}

const addMessage = (messagesArray: MessageType[], message: MessageType) => {
  const isDuplicate =
    !!message && messagesArray.some((item) => !!item && item.id === message.id)
  if (isDuplicate) {
    return messagesArray
  }
  return [...messagesArray, message]
}

const setDeletedMessage = (
  messagesArray: MessageType[],
  deletedMessage: DeletedMessageType
) => {
  const message = messagesArray.find((msg) => msg.id === deletedMessage.id)
  if (!message) {
    return messagesArray
  }

  const correctMessage: MessageType = {
    id: message.id,
    author: message.author,
    text: '',
    is_system: false,
    created_at: message.created_at,
    avatar: message.avatar,
    is_staff: message.is_staff,
    is_deleted: deletedMessage.is_deleted,
    reason_for_deletion: deletedMessage.reason_for_deletion
  }
  const arrWithoutMsg = messagesArray.filter(
    (msg) => msg.id !== deletedMessage.id
  )
  return sortMessagesByDate([...arrWithoutMsg, correctMessage])
}

const socketReducer: React.Reducer<StateType, SocketAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SET_USERS_LIST:
      return {
        ...state,
        usersList: action.payload,
      }

    case SET_MESSAGES_LIST:
      return {
        ...state,
        messagesList: action.payload,
      }

    case ADD_MESSAGE:
      return {
        ...state,
        messagesList: addMessage(state.messagesList, action.payload),
      }

    case SET_CHAT_SETTINGS:
      return {
        ...state,
        isNotificationsEnabled: action.payload.is_notifications_enabled,
      }

    case SET_ERROR_MESSAGE:
      return {
        ...state,
        error: action.payload,
      }

    case SET_USER_BLOCKED:
      return {
        ...state,
        isUserBlocked: action.payload,
      }

    case SET_MESSAGE_DELETED:
      return {
        ...state,
        messagesList: setDeletedMessage(state.messagesList, action.payload),
      }

    case SET_IS_USER_CONNECTED:
      return {
        ...state,
        isUserConnected: action.payload,
      }
    case SET_IS_SOCKET_OPENED:
      return {
        ...state,
        isSocketOpened: action.payload,
      }

    default:
      throw new Error()
  }
}

export { initialState, socketReducer }
